'use client'
import React from 'react'
import { ModalComponent } from '../common/modal/ModalComponent'
import { DrawerComponent } from '../common/drawer/DrawerComponent'
import { store } from '@/src/store/store'
import { Provider } from 'react-redux'
import { ToastProvider } from '@heroui/react'
import { toastQueue } from '@/src/lib/toast'
import NextTopLoader from 'nextjs-toploader'
import FcmTokenInitializer from './FcmTokenInitializer'

export default function AppProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Provider store={store}>
        <ToastProvider placement="bottom end" queue={toastQueue} />
        <NextTopLoader color="#407CE9" showSpinner={false} />
        <FcmTokenInitializer />
        {children}
        <ModalComponent />
        <DrawerComponent />
      </Provider>
    </>
  )
}
